import {
  FormControl,
  FormLabel,
  Box,
  Stack,
  Text,
  CheckboxGroup,
  Checkbox,
  Heading,
} from "@chakra-ui/react";
import { useFormikContext, FormikProps } from "formik";
import ButtonFooter from "../../buttons";
import { Health } from "../../type";

function General() {
  const { values, setFieldValue }: FormikProps<Health> = useFormikContext();

  const DISEASES_GENERAL = [
    "Azia e/ou Refluxo",
    "Câncer em tratamento",
    "Câncer já tratado",
    "Infecção urinária nos últimos 6 meses",
    "Insuficiência renal",
    "Tontura e/ou vertigem (labirintite)",
    "Perda de xixi",
  ];

  return (
    <Box>
      <Heading my={6} size="lg">
        Outros problemas?
      </Heading>
      <FormControl as="fieldset">
        <FormLabel as="legend">
          Passou ou passa por algum desses problemas?
        </FormLabel>

        <Text mb={4}>
          Marque todas as opções que você considerar que tem relação com seu
          estado atual de saúde.
        </Text>

        <Text mb={4}>
          Você poderá também acrescentar algo no final que não tenha aparecido
          por aqui.
        </Text>
        <CheckboxGroup
          value={values["general"]}
          onChange={(value) => setFieldValue("general", value)}
        >
          <Stack>
            {DISEASES_GENERAL.map((item) => {
              return (
                <Checkbox key={item} value={item}>
                  {item}
                </Checkbox>
              );
            })}
          </Stack>
        </CheckboxGroup>
      </FormControl>
      <ButtonFooter step="general" />
    </Box>
  );
}

export default General;
